import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { IHotel } from "../../models/BaseModel";
import { Fetch, ILazyParams } from "../../shared/Fetch";
import { Search } from "../../shared/Search";
import { IOpenForm } from "./Hotel";
import { format } from "date-fns";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { ContactTable } from "./hotelContact/ContactTable";
import { RoomTypeTable } from "./roomtype/RoomTypeTable";
import { RoomPriceTable } from "./roomPrice/PriceTable";
import { ActionMenu } from "./ActionMenu";

interface Iprops {
    setModal: (modal: IOpenForm) => void,
    toast: any,
    reload: boolean,
    reloadData: () => void,
    hasPermission: (pageName: string, featureName?: string) => boolean
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ data: [], count: 0, loading: false } as { data: IHotel[], count: number, loading: boolean });
    const [text, setText] = useState<string | null>(null);
    const [expandedRows, setExpandedRows] = useState<{ [key: string]: boolean }>({});
    const [expandedSections, setExpandedSections] = useState<{ [rowId: string]: { contact?: boolean; roomType?: boolean; roomPrice?: boolean } }>({});

    const dt = useRef<any>(null);
    const [lazyParams, setLazyParams] = useState<ILazyParams>({
        first: 0,
        rows: 25,
        page: 1,
        sortField: 'id',
        sortOrder: -1
    });

    useEffect(() => {
        loadTableData();
    }, [text, lazyParams, props.reload]);

    const onPage = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const onSort = (event: any) => {
        delete event.filters;
        delete event.multiSortMeta;
        setLazyParams(event);
    }

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch("hotel", "GET", null, `lazyParams=${JSON.stringify(lazyParams)}${text ? '&text=' + text : ''}`, props.toast);
        if (response) {
            const data: { hotels: IHotel[], count: number } = await response.json();
            setTableData({ data: data.hotels, count: data.count, loading: false });
        } else {
            setTableData((prev) => ({ ...prev, loading: false, }));
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: { status: true }, type: 'form' });
    };

    const openEdit = (rowDatauser: IHotel, type: 'form' | 'aminity') => {
        props.setModal({ open: true, singleData: rowDatauser, type: type });
    };

    const Remove = async (rowData: IHotel) => {
        setTableData((prev) => ({ ...prev, loading: true, }));
        const response = await Fetch(`hotel/${rowData.id}`, "DELETE", null, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Hotel Deleted", life: 3000 });
            loadTableData();
        }
    }

    const rejectFunc = () => { }

    const confirmDelete = (rowData: IHotel) => {
        confirmDialog({
            message: `Are you sure you want to delete "${rowData.name}"?`,
            header: 'Confirm Delete',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: 'p-button-danger',
            accept: () => Remove(rowData),
            reject: () => rejectFunc()
        });
    }

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-4">
            <div className="flex gap-4 w-full">
                {props.hasPermission("Hotel", "Add") && (
                    <Button style={{ width: '80px', height: '30px' }} label="New" icon="pi pi-plus" className="p-button-sm p-button-rounded p-button-success" onClick={openNew} />
                )}
                <div className="w-full flex align-items-center justify-content-center">
                    <h4 style={{ margin: 0, textTransform: 'uppercase', fontFamily: 'Rancho', letterSpacing: 1 }}>Hotels</h4>
                </div>
            </div>
            <div className="flex gap-4">
                <div className="p-input-icon-left">
                    <Search setSearch={setText} />
                </div>
                {props.hasPermission("Hotel", "Export") && (
                    <Button style={{ width: '80px', height: '30px' }} label="Export" icon="pi pi-upload" className="p-button-sm p-button-rounded p-button-help" onClick={exportCSV} />
                )}
            </div>
        </div>
    );

    // const toggleSection = (hotelId: number, section: 'contact' | 'roomType' | 'amenity') => {
    //     setExpandedSections(prev => {
    //         const row = prev[hotelId] || {};
    //         return {
    //             ...prev,
    //             [hotelId]: {
    //                 ...row,
    //                 [section]: !row[section]
    //             }
    //         };
    //     });
    //     setExpandedRows(prev => ({ ...prev, [hotelId]: true }));
    // };


    const toggleSection = (hotelId: number, section: 'contact' | 'roomType' | 'roomPrice') => {
        setExpandedSections(prev => {
            const current = prev[hotelId] || {};
            const isCurrentlyOpen = !!current[section];

            // 👇 Close all sections except the one being toggled
            const newSections = {
                [section]: !isCurrentlyOpen,
                contact: section === 'contact' ? !isCurrentlyOpen : false,
                roomType: section === 'roomType' ? !isCurrentlyOpen : false,
                roomPrice: section === 'roomPrice' ? !isCurrentlyOpen : false
            };

            const updated = { ...prev, [hotelId]: newSections };

            // 👇 Control expanded row visibility
            const isAnySectionOpen = Object.values(newSections).some(Boolean);
            setExpandedRows(prevExpanded => ({
                ...prevExpanded,
                [hotelId]: isAnySectionOpen
            }));

            return updated;
        });
    };


    // const actionBodyTemplate = (rowData: any) => {
    //     return (
    //         <div className="actions">
    //             {props.hasPermission("Hotel", "Edit") && <Button icon="pi pi-pencil" tooltip="Edit Hotel" tooltipOptions={{ position: "top" }} className='p-button-success p-button-text p-0' onClick={() => openEdit(rowData, 'form')} />}
    //             {props.hasPermission("Hotel", "Contact") && (<Button icon="pi pi-user" tooltip="Contact" tooltipOptions={{ position: "top" }} className="p-button-info p-button-text p-0" onClick={() => toggleSection(rowData.id, 'contact')} />)}
    //             {props.hasPermission("Hotel", "RoomType") && <Button icon="pi pi-slack" tooltip="Room Type" tooltipOptions={{ position: "top" }} className='p-button-info p-button-text p-0' onClick={() => toggleSection(rowData.id, 'roomType')} />}
    //             {props.hasPermission("Hotel", "RoomPrice") && <Button icon="pi pi-money-bill" tooltip="Room Price" tooltipOptions={{ position: "top" }} className='p-button-info p-button-text p-0' onClick={() => { toggleSection(rowData.id, 'roomPrice') }} />}
    //             {props.hasPermission("Hotel", "Aminity") && <Button icon="pi pi-box" tooltip="Aminities" tooltipOptions={{ position: "top" }} className='p-button-info p-button-text p-0' onClick={() => { openEdit(rowData, 'aminity') }} />}
    //             {props.hasPermission("Hotel", "Remove") && <Button icon="pi pi-trash" className='p-button-danger p-button-text p-0' onClick={() => { confirmDelete(rowData) }} />}
    //         </div>
    //     );
    // };

    const actionBodyTemplateDropDown = (rowData: any) => {
        return <ActionMenu
            rowData={rowData}
            hasPermission={props.hasPermission}
            openEdit={openEdit}
            toggleSection={toggleSection}
            confirmDelete={confirmDelete}
        />
    };

    const rowExpansionTemplate = (hotel: any) => {
        const rowExpanded = expandedSections[hotel.id] || {};
        return (
            <>
                {rowExpanded.contact && <ContactTable open={true} hideDialog={() => toggleSection(hotel.id, 'contact')} hotel={hotel} toast={props.toast} />}
                {rowExpanded.roomType && <RoomTypeTable hotel={hotel} open={true} hideDialog={() => toggleSection(hotel.id, 'roomType')} toast={props.toast} />}
                {rowExpanded.roomPrice && <RoomPriceTable hotel={hotel} open={true} hideDialog={() => toggleSection(hotel.id, 'roomType')} toast={props.toast} />}
            </>
        );
    };

    const statusBody = (rowData: IHotel) => {
        return (
            <div className="flex align-items-center gap-2">
                <i className={`pi ${rowData.status ? 'pi-check-circle' : 'pi-times-circle'}`} style={{ color: rowData.status ? '#4caf50' : '#f44336' }}></i>
                <span>{rowData.status ? 'Yes' : 'No'}</span>
            </div>
        );
    }

    return (
        <>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" scrollHeight="70vh" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.data} lazy dataKey="id"
                paginator first={lazyParams.first} rows={lazyParams.rows} rowsPerPageOptions={[25, 50, 100, 200]}
                totalRecords={tableData.count} onPage={onPage}
                onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                header={header}
                loading={tableData.loading}
                expandedRows={expandedRows}
                onRowToggle={(e: any) => setExpandedRows(e.data)}
                rowExpansionTemplate={rowExpansionTemplate}
            >
                <Column field="code" header="Hotel Code" sortable />
                <Column field="name" header="Hotel Name" sortable />
                <Column field="email" header="Email" />
                <Column field="phone" header="Phone" />
                <Column field="hotelCategoryName" header="Category" />
                <Column field="starRating" header="Rating" sortable body={(r: IHotel) => `${r.starRating} Star`} />
                <Column field="hotelChainName" header="Hotel Chain" />
                <Column field="location" header="Location" body={(r: IHotel) => `${r.cityName} | ${r.stateName} | ${r.countryName}`} />
                <Column field="status" header="Status" sortable body={statusBody} />
                <Column body={actionBodyTemplateDropDown} />
            </DataTable>
            <ConfirmDialog />
        </>
    );
}
